/*
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-18 15:17:40
 * @Description:
 */
export const columns = [
  {
    title: '用户名',
    dataIndex: 'studentName',
    fixed: 'left',
    width: 110,
    key: 'studentName',
    scopedSlots: { customRender: 'studentName' }
  },
  {
    title: '手机号',
    width: 120,
    fixed: 'left',
    dataIndex: 'telephone',
    key: 'telephone'
  },
  {
    title: '助学师',
    width: 120,
    dataIndex: 'teacherName',
    key: 'teacherName'
  },
  {
    title: '小组名称',
    width: 200,
    dataIndex: 'groupName',
    key: 'groupName',
    scopedSlots: { customRender: 'groupName' }
  },
  {
    title: '学年学期',
    width: 80,
    scopedSlots: { customRender: 'yearSemester' }
  },
  {
    title: '被分配课程',
    dataIndex: 'itvCourseName',
    key: 'itvCourseName',
    width: 400,
    scopedSlots: { customRender: 'itvCourseName' }
  },
  {
    title: '被分配的讲次',
    fixed: 'right',
    width: 300,
    scopedSlots: { customRender: 'lessonList' }
  },
  {
    title: '操作',
    fixed: 'right',
    width: 290,
    scopedSlots: { customRender: 'operation' }
  }
]